const DATA = [
  { name: 'Wansu Lee', position: 'Managing Partner' },
  { name: 'Yongkoo Cho', position: 'Of Counsel' },
  { name: 'Kyongsok Chong', position: 'Executive Partner' },
  { name: 'Sunkyung Shin', position: 'Executive Partner' },
]

export default DATA
